import { createPortal } from 'react-dom'
import '../styles/components/modal.css';
import modalAlertIcon from '../assets/icons/modal-alert.svg';
import Button from './Button';

const Alert = ({
  message,
  isOpen,
  onConfirm
}) => {
  if (!isOpen) return null
  
  const modalRoot = document.getElementById('modal-root')
  if (!modalRoot) return null

  return createPortal(
    <>
      <div
        role="presentation"
        className="modal-overlay"
      />
      <div className="alert-container">
        <div className="alert-content">
          <img src={modalAlertIcon} alt="" className="alert-icon" />
          <p className="alert-title gmarket-font">{message}</p>
          <Button 
            className="alert-confirm-btn gmarket-font" 
            onClick={onConfirm}
          >
            확인
          </Button>
        </div>
      </div>
    </>,
    modalRoot
  )
}

export default Alert